import React, {Component} from 'react';

// Navigation
import FooterNavigation from './FooterNavigation';
import Newsletter from './Newsletter';

const date = new Date();
const year  = date.getFullYear();

class Footer extends Component {
    render () {
        return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                                  
                    <div className="col-lg-8 col-12">

                       <FooterNavigation />
        
                    </div>
                    
                    <div className="col-lg-4 col-12">
                       <Newsletter />
                                
                    </div>
                </div>

                <div className="copyright">
                    Rascals Themes {year}
                </div>

            </div>

        </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js